import React from "react";
import { useTranslation } from "react-i18next";

function Loading() {
  const { t } = useTranslation();
  return (
    <div style={{ width: "50%", margin: "200px auto" }}>
      <h1 style={{ textAlign: "center" }}>
        {t("Loading")}{" "}
        <img src="/images/loading.gif" alt="loading" style={{ maxWidth: 25 }} />
      </h1>
    </div>
  );
}

export default Loading;
